let _initProto, _initClass, _init_open, _init_extra_open, _init_placement, _init_extra_placement, _init_delay, _init_extra_delay, _init_closeDelay, _init_extra_closeDelay, _init_portal, _init_extra_portal, _init_disabled, _init_extra_disabled, _init_contentLabel, _init_extra_contentLabel, _init_contentTarget, _init_extra_contentTarget, _init_openChangeEvent, _init_extra_openChangeEvent;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, bound, customElement, event, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { findFirstFocusableCandidate } from "@/lib/focusable-elements";
import { notePreviewClosed, notePreviewOpened, resolvePreviewOpenDelay } from "../shared/preview-timing";
import { PopoverController, shouldDismissPopoverFocus } from "../shared/popover-controller";
export const HOVER_CARD_DEFAULT_CONTENT_LABEL = "Preview";
const HOVER_CARD_GAP = 8;
const LONG_PRESS_MS = 500;
let _RuiHoverCard;
class RuiHoverCard extends RadiantElement {
  static {
    ({
      e: [_init_open, _init_extra_open, _init_placement, _init_extra_placement, _init_delay, _init_extra_delay, _init_closeDelay, _init_extra_closeDelay, _init_portal, _init_extra_portal, _init_disabled, _init_extra_disabled, _init_contentLabel, _init_extra_contentLabel, _init_contentTarget, _init_extra_contentTarget, _init_openChangeEvent, _init_extra_openChangeEvent, _initProto],
      c: [_RuiHoverCard, _initClass]
    } = _applyDecs(this, [customElement("rui-hover-card")], [[prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "open"], [prop({
      type: String,
      defaultValue: "bottom-start"
    }), 0, "placement"], [prop({
      type: Number,
      defaultValue: 600
    }), 0, "delay"], [prop({
      type: Number,
      defaultValue: 200
    }), 0, "closeDelay"], [prop({
      type: Boolean,
      defaultValue: true
    }), 0, "portal"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: String,
      attribute: "content-label",
      reflect: true,
      defaultValue: HOVER_CARD_DEFAULT_CONTENT_LABEL
    }), 0, "contentLabel"], [query({
      ref: "content"
    }), 0, "contentTarget"], [event({
      name: "rui-open-change",
      bubbles: true,
      composed: true
    }), 0, "openChangeEvent"], [[bound, onUpdated(["open", "placement", "portal", "disabled", "contentLabel"])], 2, "syncCard"], [onEvent({
      document: true,
      type: "keydown"
    }), 2, "onDocumentKeydown"], [onEvent({
      type: "focusin",
      selector: ".rui-hover-card__trigger"
    }), 2, "onFocusIn"], [onEvent({
      type: "focusout",
      selector: ".rui-hover-card__trigger"
    }), 2, "onFocusOut"], [onEvent({
      type: "keydown",
      selector: ".rui-hover-card__trigger"
    }), 2, "onHostKeydown"], [bound, 2, "onPointerEnter"], [bound, 2, "onPointerLeave"], [bound, 2, "onPointerDown"], [bound, 2, "onPointerUp"]], 0, void 0, RadiantElement));
  }
  open = (_initProto(this), _init_open(this));
  placement = (_init_extra_open(this), _init_placement(this));
  delay = (_init_extra_placement(this), _init_delay(this));
  closeDelay = (_init_extra_delay(this), _init_closeDelay(this));
  portal = (_init_extra_closeDelay(this), _init_portal(this));
  disabled = (_init_extra_portal(this), _init_disabled(this));
  contentLabel = (_init_extra_disabled(this), _init_contentLabel(this));
  contentTarget = (_init_extra_contentLabel(this), _init_contentTarget(this));
  openChangeEvent = (_init_extra_contentTarget(this), _init_openChangeEvent(this));
  contentId = (_init_extra_openChangeEvent(this), `rui-hover-card-${Math.random().toString(36).slice(2, 9)}`);
  controller = null;
  showTimer = null;
  hideTimer = null;
  longPressTimer = null;
  openedByKeyboard = false;
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("pointerenter", this.onPointerEnter);
    this.addEventListener("pointerleave", this.onPointerLeave);
    this.addEventListener("pointerdown", this.onPointerDown);
    this.addEventListener("pointerup", this.onPointerUp);
    this.addEventListener("pointercancel", this.onPointerUp);
  }
  onConnected() {
    this.syncCard();
  }
  disconnectedCallback() {
    this.clearTimers();
    if (this.open) {
      notePreviewClosed();
    }
    this.controller?.destroy();
    this.controller = null;
    this.removeEventListener("pointerenter", this.onPointerEnter);
    this.removeEventListener("pointerleave", this.onPointerLeave);
    this.removeEventListener("pointerdown", this.onPointerDown);
    this.removeEventListener("pointerup", this.onPointerUp);
    this.removeEventListener("pointercancel", this.onPointerUp);
    super.disconnectedCallback();
  }
  clearTimers() {
    if (this.showTimer) clearTimeout(this.showTimer);
    if (this.hideTimer) clearTimeout(this.hideTimer);
    if (this.longPressTimer) clearTimeout(this.longPressTimer);
    this.showTimer = null;
    this.hideTimer = null;
    this.longPressTimer = null;
  }
  getAnchor() {
    const trigger = this.querySelector("[data-hover-card-trigger]");
    if (trigger instanceof HTMLElement) {
      return findFirstFocusableCandidate(trigger) ?? trigger;
    }
    return findFirstFocusableCandidate(this) ?? this;
  }
  getFloatingElement() {
    return this.controller?.getFloatingElement() ?? this.contentTarget;
  }
  ensureController() {
    if (!this.controller) {
      this.controller = new PopoverController({
        getAnchor: () => this.getAnchor(),
        getFloating: () => this.contentTarget,
        getOpen: () => this.open,
        getPlacement: () => this.placement,
        gap: HOVER_CARD_GAP,
        portal: this.portal
      });
    }
    return this.controller;
  }
  syncCard() {
    const anchor = this.getAnchor();
    const surface = this.contentTarget;
    if (surface) {
      surface.id = this.contentId;
      surface.setAttribute("aria-label", this.contentLabel);
    }
    if (anchor) {
      anchor.setAttribute("aria-controls", this.contentId);
      anchor.setAttribute("aria-expanded", String(this.open));
    }
    const controller = this.ensureController();
    controller.updateConfig({
      getAnchor: () => this.getAnchor(),
      getFloating: () => this.contentTarget,
      getOpen: () => this.open,
      getPlacement: () => this.placement,
      gap: HOVER_CARD_GAP,
      portal: this.portal
    });
    controller.sync();
    this.syncContentPointerBridge();
  }
  syncContentPointerBridge() {
    const surface = this.getFloatingElement();
    if (!surface) {
      return;
    }
    surface.removeEventListener("pointerenter", this.onPointerEnter);
    surface.removeEventListener("pointerleave", this.onPointerLeave);
    if (this.open) {
      surface.addEventListener("pointerenter", this.onPointerEnter);
      surface.addEventListener("pointerleave", this.onPointerLeave);
    }
  }
  setOpen(next, emit = true) {
    if (this.disabled && next) {
      return;
    }
    if (this.open === next) {
      this.syncCard();
      return;
    }
    const wasOpen = this.open;
    this.open = next;
    if (next) {
      notePreviewOpened();
    } else if (wasOpen) {
      notePreviewClosed();
    }
    if (emit) {
      this.openChangeEvent.emit({
        open: next
      });
    }
    this.syncCard();
  }
  scheduleShow(fromKeyboard = false) {
    if (this.disabled || this.open) {
      return;
    }
    this.clearTimers();
    this.openedByKeyboard = fromKeyboard;
    const effectiveDelay = resolvePreviewOpenDelay(this.delay);
    if (effectiveDelay <= 0) {
      this.setOpen(true);
      return;
    }
    this.showTimer = setTimeout(() => this.setOpen(true), effectiveDelay);
  }
  scheduleHide() {
    this.clearTimers();
    const delay = this.closeDelay > 0 ? this.closeDelay : 0;
    if (delay <= 0) {
      this.setOpen(false);
      return;
    }
    this.hideTimer = setTimeout(() => this.setOpen(false), delay);
  }
  isTouchPointer(event2) {
    return event2.pointerType === "touch";
  }
  onDocumentKeydown(event2) {
    if (!this.open || event2.key !== "Escape") {
      return;
    }
    event2.preventDefault();
    this.setOpen(false);
    this.getAnchor()?.focus();
  }
  onFocusIn() {
    this.scheduleShow(true);
  }
  onFocusOut(event2) {
    if (!shouldDismissPopoverFocus(this.getAnchor(), this.getFloatingElement(), event2.relatedTarget)) {
      return;
    }
    this.scheduleHide();
  }
  onHostKeydown(event2) {
    if (!this.open || event2.key !== "Tab" || event2.shiftKey || !this.openedByKeyboard) {
      return;
    }
    const floating = this.getFloatingElement();
    if (!floating) {
      return;
    }
    const first = findFirstFocusableCandidate(floating);
    if (!first) {
      return;
    }
    event2.preventDefault();
    first.focus();
  }
  onPointerEnter(event2) {
    if (this.isTouchPointer(event2)) {
      return;
    }
    this.scheduleShow();
  }
  onPointerLeave(event2) {
    if (this.isTouchPointer(event2)) {
      return;
    }
    this.scheduleHide();
  }
  onPointerDown(event2) {
    if (this.disabled || !this.isTouchPointer(event2)) {
      return;
    }
    this.clearTimers();
    this.longPressTimer = setTimeout(() => {
      this.openedByKeyboard = false;
      this.setOpen(true);
    }, LONG_PRESS_MS);
  }
  onPointerUp() {
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }
  }
  static {
    _initClass();
  }
}
export { _RuiHoverCard as RuiHoverCard };